<section class="group-register" *appHasPermission="groupPermissions.MODULE">
  <div class="group-register__header">
    <app-breadcrumb [home]="home" [items]="breadcrumbs"></app-breadcrumb>
    <div class="group-register__header__map">
      <i class="pi pi-map d-none"></i>
    </div>
  </div>
  <div class="group-register__header">
    <div class="group-register__header__title">
      <div class="group-register__header__title__icon" (click)="cancelRegister()">
        <i class="pi pi-arrow-left"></i>
      </div>
      <h1>{{ tk.User.NewGroup | t }}</h1>
    </div>
    <div class="group-register__header__actions">
      <div class="group-register__header__actions__button">
        <app-button
          [id]="'cancel-register'"
          [label]="tk.User.Cancel | t"
          [type]="'button'"
          [theme]="'white'"
          (sendButtonClick)="cancelRegister()"></app-button>
      </div>
      <div
        class="group-register__header__actions__button"
        *appHasPermission="groupPermissions.CREATE">
        <app-button
          [id]="'register-group'"
          [label]="tk.User.Finish | t"
          [type]="'button'"
          [disabled]="groupsRegisterForm.invalid || !permissionsCountSelected"
          (sendButtonClick)="registerGroup()"></app-button>
      </div>
    </div>
  </div>
  <div class="group-register__content">
    <form *ngIf="groupsRegisterForm" [formGroup]="groupsRegisterForm" appAutoFormGroup>
      <div class="form-group">
        <div class="row">
          <div class="col-12 col-sm-6 col-md-3">
            <app-select
              [disabled]="groupId !== undefined && groupId.length > 0"
              [label]="tk.User.Type | t"
              [options]="userTypeOptions"
              [selectedOption]="selectedUserType"
              (sendSelectedOption)="handleOptionChange($event, 'selectedUserType')"
              [placeholder]="tk.User.Select | t"></app-select>
          </div>
          <div class="col-12 col-sm-6 col-md-9">
            <app-input
              [type]="'text'"
              [placeholder]="tk.User.FirstName | t"
              [controlName]="groupRegisterProps.name"
              [label]="tk.User.Name | t"
              [required]="true"></app-input>
          </div>
        </div>
        <ng-container *ngIf="permissions?.length">
          <div class="col-12">
            <div formArrayName="permissions">
              <div class="permissions-grid">
                <!-- Container para cada grupo de permissão -->
                <div
                  *ngFor="let permission of permissions; let iPermission = index"
                  class="permission-group">
                  <!-- Cabeçalho do grupo -->
                  <div class="permission-group__header p-3 mt-4 bg-gray-100 border rounded-b-lg">
                    <h3>
                      {{ permission.description }}
                      <sup> {{ getTabHeader(permission) }}</sup>
                    </h3>
                  </div>

                  <!-- Conteúdo do grupo -->
                  <div
                    [formGroupName]="iPermission"
                    class="permission-group__content p-3 border rounded-b-lg">
                    <!-- Checkbox principal -->
                    <div class="mb-3">
                      <app-checkbox
                        [checkbox]="permissionsCheckboxes[iPermission]"
                        [hasSelectionHighlight]="true"
                        [highlight]="true"
                        (sendCheckedChange)="handleCheckedChange($event, 'main')">
                      </app-checkbox>
                    </div>

                    <!-- Lista de claims -->
                    <div class="pl-6">
                      <ng-container *ngFor="let claim of permission.claims; let iClaim = index">
                        <app-checkbox
                          [hasSelectionHighlight]="true"
                          [checkbox]="checkboxesFormClaims[iPermission][iClaim]"
                          (sendCheckedChange)="handleCheckedChange($event, 'sub')">
                        </app-checkbox>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </form>
  </div>
</section>

<style>
  .permissions-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 1rem;
  }

  .permission-group {
    width: 320px;
  }

  .permission-group__header {
    width: 320px;
    height: 40px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .permission-group__header h3 {
    font-weight: bold;
    font-size: 1.1rem;
  }

  .permission-group__content {
    width: 320px;
    height: 320px;
    overflow-y: auto;
    overflow-x: hidden;
  }

  /* Estilização da scrollbar para melhor aparência */
  .permission-group__content::-webkit-scrollbar {
    width: 8px;
  }

  .permission-group__content::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }

  .permission-group__content::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
  }

  .permission-group__content::-webkit-scrollbar-thumb:hover {
    background: #666;
  }
</style>
